import {
    SET_REPORT_DETAILS,
    SET_RESPONSE_MATRIX,
    GET_RESPONSE_MATRIX,
    SET_NEW_GROUP,
    GET_GROUPS,
    SET_ITEM,
    GET_ITEMS,
    GET_TEMPLATES,
    REMOVE_TEMPLATE,
    SELECTED_TEMPLATE
} from "./types";
import firebase from "firebase/app";

export const getTemplates = () => {
    return dispatch => {
        dispatch({ type: GET_TEMPLATES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_TEMPLATES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/report_templates`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_TEMPLATES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TEMPLATES.FAIL });
        }
    };
};

export const getCopyTemplate = (ref) => {
    return dispatch => {
        dispatch({ type: SELECTED_TEMPLATE.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SELECTED_TEMPLATE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/report_templates/${id}/`)
                        .on("value", snapshot => {
                            dispatch({
                                type: SELECTED_TEMPLATE.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_TEMPLATES.FAIL });
        }
    };
};

export const templateCopy = (ref,data,path) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    // callback(true);
                } 
                firebase
                    .database()
                    .ref(`/collections/${path}/${id}`)
                    .update(data)
                    .then(() => {
                        firebase
                            .database()
                            .ref(`/collections/${path}/${id}/profile/`)
                            .update({report_title : ref})
                        dispatch({
                            type: SET_REPORT_DETAILS.SUCCESS
                        })
                    })
                    // callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        // callback(true);
    };
};

export const removeTemplate = (ref) => {
    return dispatch => {
        dispatch({ type: REMOVE_TEMPLATE.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: REMOVE_TEMPLATE.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/report_templates`)
                    .child(`${id}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: REMOVE_TEMPLATE.FAIL });
        }
    };
};


export const getGroups = (templateName) => {
    return dispatch => {
        dispatch({ type: GET_GROUPS.REQUEST });
        let reference = templateName.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_GROUPS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/report_templates/${id}/details/groups`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_GROUPS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_GROUPS.FAIL });
        }
    };
};

export const getItems = (templateName, gid) => {
    return dispatch => {
        dispatch({ type: GET_ITEMS.REQUEST });
        let reference = templateName.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_ITEMS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/report_templates/${id}/details/groups/${gid}/items`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_ITEMS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_ITEMS.FAIL });
        }
    };
};


export const setReportDetails = (details, callback) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = details.report_title.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    callback(true);
                } 
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/profile`)
                    .update(details);
                    callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        callback(true);
    };
};

export const addGroup = (group, gname, ref) => {
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_GROUP.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/groups/${gname}/profile`)
                    .update(group);
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};

export const editGroup = (group, uid, ref) => {
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_GROUP.FAIL });
                }
                
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/groups/${uid}/profile`)
                    .update(group);
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};

export const removeGroup = ( uid, ref) => {
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_GROUP.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/groups`)
                    .child(`${uid}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};

export const addItem = (item,itemid, groupid, ref) => {
    return dispatch => {
        dispatch({ type: SET_ITEM.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_ITEM.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/groups/${groupid}/items/${itemid}`)
                    .update(item);
            });
        } catch (e) {
            dispatch({ type: SET_ITEM.FAIL });
        }
    };
};

export const editItem = (item, gid, itemid, ref) => {
    
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_GROUP.FAIL });
                }
                
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/groups/${gid}/items/${itemid}`)
                    .update(item);
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};

export const removeItem = ( gid, itemId, ref) => {
    return dispatch => {
        dispatch({ type: SET_NEW_GROUP.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_NEW_GROUP.FAIL });
                }
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/groups/${gid}/items`)
                    .child(`${itemId}`)
                    .remove();
            });
        } catch (e) {
            dispatch({ type: SET_NEW_GROUP.FAIL });
        }
    };
};

export const setSection1 = (section1, ref, callback) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    callback(true);
                }   
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/section_1`)
                    .update(section1);
                    callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        callback(true);
    };
};
export const setSection2 = (section2, ref,callback) => {
    return dispatch => {
        dispatch({ type: SET_REPORT_DETAILS.REQUEST });
        let reference = ref.replace(/ /g,"_");
        let id = `custom_${reference}`
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: SET_REPORT_DETAILS.FAIL });
                    callback(true);
                }
                firebase
                    .database()
                    .ref(`/collections/report_templates/${id}/details/section_2`)
                    .update(section2);
                    callback(false);
            });
        } catch (e) {
            dispatch({ type: SET_REPORT_DETAILS.FAIL });
        }
        callback(true);
    };
};


export const archieveTemplate = (ref) => {
    let reference = ref.replace(/ /g,"_");
    let id = `custom_${reference}`
    return dispatch => {
        dispatch({ type: REMOVE_TEMPLATE.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: REMOVE_TEMPLATE.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/report_templates/${id}/profile/`)
                        .update({deleted : true});
                }
            });
        } catch (e) {
            dispatch({ type: REMOVE_TEMPLATE.FAIL });
        }
    };
};

export const setResponseMatrixStatus = (status) => {
    return dispatch => {
        dispatch({ type: SET_RESPONSE_MATRIX.REQUEST });

        try {
            firebase.auth().onAuthStateChanged( async user => {
                if (user === null) {
                    dispatch({ type: SET_RESPONSE_MATRIX.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/response_matrix/`)
                        .update({response_matrix_status: status})
                    
                    dispatch({ type: SET_RESPONSE_MATRIX.SUCCESS });
                    
                }
            });
        } catch (e) {
            dispatch({ type: SET_RESPONSE_MATRIX.FAIL });
        }
    };
};

export const getResponseMatrix = () => {
    return dispatch => {
        dispatch({ type: GET_RESPONSE_MATRIX.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_RESPONSE_MATRIX.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/response_matrix")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_RESPONSE_MATRIX.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_RESPONSE_MATRIX.FAIL });
        }
    };
};

export const updateMatrix = (i,status,value) => {
    return dispatch => {
        dispatch({ type: SET_RESPONSE_MATRIX.REQUEST });

        try {
            firebase.auth().onAuthStateChanged( async user => {
                if (user === null) {
                    dispatch({ type: SET_RESPONSE_MATRIX.FAIL });
                } else {
                    if(status==="green"){
                        firebase
                        .database()
                        .ref(`/collections/response_matrix/${i}/`)
                        .update({green:value})
                    }
                    else if(status==="a1"){
                        firebase
                        .database()
                        .ref(`/collections/response_matrix/${i}/`)
                        .update({a1:value})
                    }
                    else if(status==="a2"){
                        firebase
                        .database()
                        .ref(`/collections/response_matrix/${i}/`)
                        .update({a2:value})
                    }
                    else if(status==="a3"){
                        firebase
                        .database()
                        .ref(`/collections/response_matrix/${i}/`)
                        .update({a3:value})
                    }
                    else{
                        firebase
                        .database()
                        .ref(`/collections/response_matrix/${i}/`)
                        .update({red:value})
                    }
                    dispatch({ type: SET_RESPONSE_MATRIX.SUCCESS });
                }
            });
        } catch (e) {
            dispatch({ type: SET_RESPONSE_MATRIX.FAIL });
        }
    };
};




